import React, { ReactNode } from 'react';
import { Grid, Typography } from '@mui/material';
import styles from "../../../assets/styles/componentStyles/apiKeyStyles/apiKeyStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";

interface ApiKeyInformationCardProps {
    icon: ReactNode;
    title: string;
    description: ReactNode;
    iconColor: string;
}

const ApiKeyInfoCard: React.FC<ApiKeyInformationCardProps> = (props) => {
    const { icon, title, description, iconColor } = props;

    const getBackgroundColorOfIcon = (color: string) => {
        if (color.startsWith('#')) {
            return `${color}1A !important`; // 10% opacity
        }
        return color;
    };

    return (
        <Grid container className={styles.infoCard}>
            <Grid item 
                className={styles.cardIcon} 
                sx={{
                    backgroundColor: getBackgroundColorOfIcon(iconColor),
                    color: `${iconColor} !important`
                }}
            >
                {icon}
            </Grid>
            <Grid item xs>
                <Typography component="div" className={`${styles.cardTitle} ${globalStyles.secondaryFontSize} ${globalStyles.primaryFontWeight}`}>
                    {title}
                </Typography>
                <Typography component="div" className={`${styles.cardDesc} ${globalStyles.tertiaryFontSize} ${globalStyles.tertiaryFontWeight}`}>
                    {description}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default ApiKeyInfoCard;
